import { usePermission } from '@backstage/plugin-permission-react';
import { platformAdminViewPermission } from '@internal/plugin-rbac-common';

/**
 * True only for members of `rbac.platformAdmins`. Resolved through the
 * permission backend rather than by reading the signed-in user's groups, so
 * the frontend never becomes a second source of truth for who is an admin.
 *
 * Returns false while the check is in flight: an operator surface flashing
 * into the sidebar and then disappearing reads as a bug, and the opposite
 * mistake (a hidden item appearing a moment later) is harmless.
 */
export function useIsPlatformAdmin(): boolean {
  const { loading, allowed } = usePermission({
    permission: platformAdminViewPermission,
  });

  return !loading && allowed;
}
